import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { IconButton, Stack, Typography, Button } from "@mui/material";
import { CloseOutlined, CheckCircle } from "@mui/icons-material";
import { useState } from "react";
import { toggleDrawer } from "../../utils/utils";
import CloseBook from "./CloseBook";
import { SettingsDetailsType } from "../../types/genericType";

type BooksDrawerProps = {
  onSuccess: Function;
  setSnackbarMsg: Function;
  settingsData: SettingsDetailsType;
};

const BooksDrawer = ({ settingsData, onSuccess, setSnackbarMsg }: BooksDrawerProps) => {
  const [open, setOpen] = useState(false);
  //   const { clientOptions } = useClientDetails();

  const handleDrawerOpen = toggleDrawer<React.KeyboardEvent | React.MouseEvent>(
    true,
    setOpen
  );
  const handleDrawerClose = () => {
    setOpen(false);
  };


  const drawerComp = (
    <Stack>
      <Box className="drawer-header" role="presentation">
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          fontWeight={700}
        >
          Summary
        </Typography>
        <IconButton
          aria-label="toggle password visibility"
          onClick={handleDrawerClose}
          size="large"
        >
          <CloseOutlined />
        </IconButton>
      </Box>
      <CloseBook
        settingsData={settingsData}
        setOnTxnSuccess={onSuccess}
        setSnackbarMsg={setSnackbarMsg}
        handleDrawerClose={handleDrawerClose}
      />
    </Stack>
  );

  return (
    <div className="transaction-drawer">
      <React.Fragment>
        <Button
          variant="contained"
          color="primary"
          className="new-btn"
          onClick={handleDrawerOpen}
          component="button"
        >
          <CheckCircle className="add-icon" />
          Close books
        </Button>
        <Drawer
          anchor="right"
          variant="temporary"
          open={open}
          sx={{
            display: { xs: "none", sm: "block" },
            "&.MuiDrawer-root .MuiDrawer-paper": {
              marginTop: "65px",
              width: "436px",
            },
          }}
        >
          {drawerComp}
        </Drawer>
      </React.Fragment>
    </div>
  );
};

export default BooksDrawer;
